import React from 'react';

const SelectValue = ({ children }) => {
  return <span>{children}</span>;
};

SelectValue.displayName = 'SelectValue';
export default SelectValue;
